/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialAdvisorDtoSearchResponse } from '../../models/financial-advisor-dto-search-response';

export interface SearchFinancialAdvisors$Plain$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
}

export function searchFinancialAdvisors$Plain(http: HttpClient, rootUrl: string, params?: SearchFinancialAdvisors$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialAdvisorDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchFinancialAdvisors$Plain.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialAdvisorDtoSearchResponse>;
    })
  );
}

searchFinancialAdvisors$Plain.PATH = '/api/financial-advisor';
